// src/components/Grade10Examinations.js
import React from 'react';
import ExamsList from './ExamsListPerYear';

const Grade10evaluations = ({ isLoggedIn, clearToken }) => {
    const items = [
        { name: 'GRADE 10 EVALUATIONS 2026', year: 2026, bgColor: 'rgba(0, 0, 0, 0.2)', textColor: 'rgb(0, 0, 0)', path: "senior/school", value: "grade10/evaluations" },
        { name: 'GRADE 10 EVALUATIONS 2025', year: 2025, bgColor: 'rgba(0, 0, 0, 0.1)', textColor: 'rgb(0, 0, 0)', path: "senior/school", value: "grade10/evaluations" },

    ];

    return (
        <ExamsList           
            heading="GRADE 10"
            items={items}
            navigateTo="/grade10/evaluations/downloads"
        />
    );
};

export default Grade10evaluations;
